import { MapProviderType } from './IMapProvider';

/**
 * Global map provider configuration
 * Change this value to switch between different map providers across the entire application
 */
export const MAP_PROVIDER_CONFIG = {
  // Change this to switch providers: LEAFLET, GOOGLE_MAPS, MAPBOX, etc.
  defaultProvider: MapProviderType.LEAFLET,
};